import { LinearProgress } from '@material-ui/core';
import React from 'react';

export const AbsoluteLinearProgress = (props: {
  show: boolean;
  position?: 'top' | 'bottom';
  style?: React.CSSProperties;
}) => {
  const { show, position = 'top', style = {} } = props;
  const linearProgressStyle = {
    bottom: position === 'bottom' ? '0px' : 'auto',
    top: position === 'top' ? '0px' : 'auto',
    position: 'absolute',
    width: '100%',
    transition: 'all 0.5s',
    ...style,
  } as React.CSSProperties;

  return (
    <LinearProgress
      style={
        show
          ? {
              ...linearProgressStyle,
              opacity: 1,
            }
          : {
              ...linearProgressStyle,
              opacity: 0,
            }
      }
    />
  );
};
